import { actions, basic, basicIcon, dismissIcon, error, errorIcon, iconContainer, infoIcon, information, message, pending, pendingIcon, success, successIcon, warning, warningIcon, } from '../styles/legacy';
import { actions as actionsCitrus2022, basic as basicCitrus2022, basicIcon as basicIconCitrus2022, dismissIcon as dismissIconCitrus2022, error as errorCitrus2022, errorIcon as errorIconCitrus2022, iconContainer as iconContainerCitrus2022, infoIcon as infoIconCitrus2022, information as informationCitrus2022, message as messageCitrus2022, pending as pendingCitrus2022, pendingIcon as pendingIconCitrus2022, success as successCitrus2022, successIcon as successIconCitrus2022, warning as warningCitrus2022, warningIcon as warningIconCitrus2022, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var IconContainer = citrusStyled.div('iconContainer', {
    legacy: iconContainer,
    citrus2022: iconContainerCitrus2022,
});
export var Message = citrusStyled.div('message', { legacy: message, citrus2022: messageCitrus2022 });
export var Actions = citrusStyled.div('actions', { legacy: actions, citrus2022: actionsCitrus2022 });
export var BasicBanner = citrusStyled.div('basic', { legacy: basic, citrus2022: basicCitrus2022 });
export var InformationBanner = citrusStyled.div('information', {
    legacy: information,
    citrus2022: informationCitrus2022,
});
export var SuccessBanner = citrusStyled.div('success', { legacy: success, citrus2022: successCitrus2022 });
export var WarningBanner = citrusStyled.div('warning', { legacy: warning, citrus2022: warningCitrus2022 });
export var ErrorBanner = citrusStyled.div('error', { legacy: error, citrus2022: errorCitrus2022 });
export var PendingBanner = citrusStyled.div('pending', { legacy: pending, citrus2022: pendingCitrus2022 });
export var BasicIcon = citrusStyled.i('basicIcon', { legacy: basicIcon, citrus2022: basicIconCitrus2022 });
export var DismissIcon = citrusStyled.i('dismissIcon', { legacy: dismissIcon, citrus2022: dismissIconCitrus2022 });
export var ErrorIcon = citrusStyled.i('errorIcon', { legacy: errorIcon, citrus2022: errorIconCitrus2022 });
export var InfoIcon = citrusStyled.i('infoIcon', { legacy: infoIcon, citrus2022: infoIconCitrus2022 });
export var PendingIcon = citrusStyled.i('pendingIcon', { legacy: pendingIcon, citrus2022: pendingIconCitrus2022 });
export var SuccessIcon = citrusStyled.i('successIcon', { legacy: successIcon, citrus2022: successIconCitrus2022 });
export var WarningIcon = citrusStyled.i('warningIcon', { legacy: warningIcon, citrus2022: warningIconCitrus2022 });
export var Styled = {
    IconContainer: IconContainer,
    Message: Message,
    Actions: Actions,
    BasicBanner: BasicBanner,
    InformationBanner: InformationBanner,
    SuccessBanner: SuccessBanner,
    WarningBanner: WarningBanner,
    ErrorBanner: ErrorBanner,
    PendingBanner: PendingBanner,
    BasicIcon: BasicIcon,
    DismissIcon: DismissIcon,
    ErrorIcon: ErrorIcon,
    InfoIcon: InfoIcon,
    PendingIcon: PendingIcon,
    SuccessIcon: SuccessIcon,
    WarningIcon: WarningIcon,
};
